import { triggerAdmissionsInfoMobileBox } from 'AdmissionsHelp';
import { type DialogModal } from 'DialogModal';

export default function onClickAdmissionsQuestion(injector: angular.auto.IInjectorService) {
    const DialogModal = injector.get<DialogModal>('DialogModal');
    triggerAdmissionsInfoMobileBox(injector);
    DialogModal.hideAlerts();
}
